<template>
  <router-view />
  <EnvironmentIndicator />
</template>

<script setup lang="ts">
import EnvironmentIndicator from 'src/components/EnvironmentIndicator.vue';
</script>
